import workspaceQuery from '../../../graphql/queries/sales/ImportedShopifyOrderWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/ImportedShopifyOrderListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/ImportedShopifyOrderQuery.graphql';
import mutationQuery from '../../../graphql/mutations/sales/ImportedShopifyOrderMutation.graphql';
import fragment from '../../../graphql/fragments/sales/ImportedShopifyOrderFragment.graphql';
import aggregateQuery from '../../../graphql/queries/sales/ImportedShopifyOrderAggregateQuery.graphql';

import { workspace } from '../../../actions/sales/ImportedOrderWorkspaceAction';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const ImportedShopifyOrder: EntityType = {
  type: 'ImportedShopifyOrder',
  title: 'Shopify Orders',
  formTitle: 'Imported Shopify Order',
  workspaceUrl: '/Sales/Channel/ImportedShopifyOrder/Workspace/',
  formUrl: '/Sales/Channel/ImportedShopifyOrder/Details/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'orderReference',
  },
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'IMPORTED_SHOPIFY_ORDERS',
  actions: workspace,
  operations: ALLOW_VIEW,
};

export default ImportedShopifyOrder;
